import { useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../components/PageTitle";
import OrderMedicationForm from "../../components/Orders/OrderMedicationForm";
import { Button, Spin } from "antd";
import PatientInformationHeader from "../../components/Patient/PatientInformationHeader";
import { useCreateOrderFromMedSheetDataMutation, useGetOrderTemplateQuery, useGetPatientDetailsQuery } from "../../features/patient/patientService";
import { mapOrderTemplateToOrderResponse } from "../../models/PatientModels";

const OneTimeEditMedsheet = () => {
    const navigate = useNavigate();
    const { id: patientId = '' } = useParams();
    const { medsheetId = '' } = useParams();

    const { data: patientDetails, isLoading: isPatientLoading } = useGetPatientDetailsQuery({id: patientId});
    const { data: templateDetails, isLoading: isTemplateLoading } = useGetOrderTemplateQuery({templateId: medsheetId, patientId: patientId});

    const [createOrder, {isLoading}] = useCreateOrderFromMedSheetDataMutation();
    
    return (
            <div>
                <PageTitle
                    title="Update Medsheet"
                    onClick={() => navigate(-1)}
                />

                <Spin spinning={isPatientLoading || isTemplateLoading} className="h-100 w-100 align-content-center" size="large"  />


                {patientDetails && templateDetails && (      
                    
                    <div className="mx-5">

                        <PatientInformationHeader
                                patient={patientDetails}
                                navigate={() => navigate(-1)}
                                isPatientDashboardVisible={false}
                            />

                        <div className="mt-3 max-w-750"> 
                            <span >
                                <b className="text-light-gray">Note: </b> 
                                Changes made here will not update the original Med Sheet pulled from the EMR. This is one-time for this medication order only.
                            </span>
                        </div>

                        <OrderMedicationForm
                            toastMessage="Medication successfully created."
                            
                            cancelButton={
                                <Button
                                    onClick={() =>
                                        navigate(-1)
                                    }
                                    className="me-4"
                                    style={{
                                        width: 120,
                                        color: 'var(--hcrx-light-blue)',
                                        borderColor: 'var(--hcrx-light-blue)',
                                    }}
                                    shape="round"
                                >
                                    Cancel
                                </Button>
                            }
                            onSubmit={createOrder}
                            isSubmitting={isLoading}
                            submitLabel="Review & Submit"
                            isMedsheetOneTimeUpdate={true}
                            order={mapOrderTemplateToOrderResponse(templateDetails, patientId)}
                        />
                        
                    </div>
                )}

        </div>
    );
}

export default OneTimeEditMedsheet;
